// const fetch = require('node-fetch');

// const fiatInfo = require('./fiats/merge')
import fiatInfo from './fiats/merge'
import proxyWrapper from './proxyCors';







// Modelo coin
// {
//     name: String
//     iconUrl: String
//     price: Number
// }



/**
 * Fetch in https://coinranking.com
 * @param {string} base - USD, BRL, EUR, GBP
 */
const cripto = (base) => fetch('/.netlify/functions/apicripto/')
    .then(response => {
        if (!response.ok) {
            throw new Error('Erro na conexão - cripto');
        }
        return response.json()
    })
    .catch(err => err)

/**
 * Fetch in https://api.exchangeratesapi.io
 * @param {string} base - USD, BRL, EUR, GBP
 */
/** http://api.exchangeratesapi.io/v1/latest?access_key=8112c5567d7665cb5255bf0cc68b2e43 */
// const fiat = (base) => fetch(`https://api.exchangeratesapi.io/latest?base=${base}`)
const fiat = (base) => fetch(`https://api.currencyfreaks.com/latest?apikey=${process.env.REACT_APP_API_KEY_CURRENCYFREAKS}`) // BASE usd
    // const fiat = (base) => fetch(`http://api.exchangeratesapi.io/v1/latest?access_key=${process.env.REACT_APP_API_KEY_EXCHANGERATESAPI}&base=${base}`)
    .then(response => {
        if (!response.ok) {
            throw new Error('Erro na conexão - fiat');
        }
        return response.json()
    })
    // .then(response => response.data)
    .catch(err => err)



/**
 * 
 * @param {string} base - USD, BRL, EUR, GBP
 */
const coins = (base) => Promise.all([cripto(base), fiat(base)])
    .then(values => {

        const criptoApi = values[0]
        const fiatApi = values[1]

        // console.log(criptoApi);
        // console.log(fiatApi);

        const _criptoCoins = criptoApi.data.coins.map((item, index) => {
            return {
                name: item.name,
                iconUrl: item.iconUrl,
                symbol: item.symbol,
                price: Number.parseFloat(item.price),
                cripto: true
            }
        })

        const _fiatCoins = Object.keys(fiatInfo).map(function (key, index) {
            return {
                ...fiatInfo[key],
                symbol: key,
                price: 1 / fiatApi.rates[key], // invertendo para igualar base de conversao
                cripto: false
            }
        })


        const result = {
            base: base,
            timestamp: new Date(),
            fiatCoins: _fiatCoins,
            allCoins: _fiatCoins.concat(_criptoCoins)

        }
        // console.log('result: ', result);

        return result
    })
    .catch(err => new Promise((resolve, reject) => {
        reject(new Error(err));
    }))
// .catch(err => new Error('Erro na conexão - cripto'))


export default {
    coins
}
// module.exports = {
//     coins,
//     cripto,
//     fiat
// }